import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'frontend-no-chat-selected',
  templateUrl: 'no-chat-selected.component.html',
  styleUrls: ['no-chat-selected.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NoChatSelectedComponent {}
